import { Dialog, DialogContent } from "@/components/ui/Dialog"
import { Spinner } from "@/components/ui/Spinner"

interface LoadingDialogProps {
  message?: string
  onClose: () => void
}

export function LoadingDialog({ message, onClose }: LoadingDialogProps) {
  return (
    <Dialog
      open={true}
      onOpenChange={(isOpen: boolean) => !isOpen && onClose()}
    >
      <DialogContent className="tw-max-w-lg tw-font-sansAlt tw-border-0 tw-shadow-2xl">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-px-6">
          <div className="tw-relative">
            {/* Outer glow ring */}
            <div className="tw-absolute tw-inset-0 tw-rounded-full tw-bg-green-200 tw-opacity-20 tw-blur-xl tw-animate-pulse" />

            {/* Spinner */}
            <div className="tw-relative">
              <Spinner className="tw-h-16 tw-w-16 tw-text-green-600" />
            </div>
          </div>

          <p className="tw-mt-6 tw-text-center tw-text-base tw-font-medium tw-text-gray-700 tw-animate-pulse">
            {message || "Loading..."}
          </p>

          <div className="tw-flex tw-gap-1 tw-mt-3">
            <div
              className="tw-h-2 tw-w-2 tw-rounded-full tw-bg-green-500 tw-animate-bounce"
              style={{ animationDelay: "0ms" }}
            />
            <div
              className="tw-h-2 tw-w-2 tw-rounded-full tw-bg-green-500 tw-animate-bounce"
              style={{ animationDelay: "150ms" }}
            />
            <div
              className="tw-h-2 tw-w-2 tw-rounded-full tw-bg-green-500 tw-animate-bounce"
              style={{ animationDelay: "300ms" }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
